// Resolve the API base URL.
//
// In production (taxi-98.com / www.taxi-98.com) we ALWAYS use the page's own
// origin so API calls stay same-origin. This avoids two production bugs:
//   1. Cross-origin preflight between apex (taxi-98.com) and the www subdomain
//      that Cloudflare resolves to.
//   2. The Cloudflare 308 apex -> www redirect on CORS preflight requests,
//      which browsers block per the CORS spec ("Redirect is not allowed for a
//      preflight request").
//
// In every other environment (preview, local, etc.) we fall back to the
// build-time REACT_APP_BACKEND_URL value.

const PROD_HOSTS = new Set(['taxi-98.com', 'www.taxi-98.com']);

export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && PROD_HOSTS.has(window.location.hostname)) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL;
};
